module.exports = {
      id: "home-usage",
      viewBox: "0 0 15.417 13.987",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#home",
      toString: function () {
        return this.url;
      }
    }